import { useMemo } from "react";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
} from "../../../../../../stores/LeadsStore";
import {
  ActionIcon,
  Avatar,
  Group,
  Paper,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconPhone } from "@tabler/icons-react";
import PositiveChanger from "../../actions/PositiveChanger";
import AddReminder from "../Right/reminder/AddReminder";
import QuickAddNote from "./QuickAddNote";
import { tagsColumn } from "../../../../../../layouts/Table/columns/tagsColumn";
import { updateProspect } from "../../../../../../api/PRMAPI";
import EmailSenderModal from "../Right/answers/email/EmailSenderModal";
import { IconLinkedin } from "../../../../../../components/Icons/IconLinkedin";
import { Link } from "react-router-dom";
import ConversationStart from "../Right/answers/email/ConversationStart";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const MainBio = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);
  const setActiveTab = useLeadsSheetStore((s) => s.setActiveTab);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );

  const onTagEdited = (newTags) => {
    setCurrent({ ...current, tags: newTags });
    updateContainerItem(currentContainer.id, current.id, { tags: newTags });
  };

  const about = useMemo(() => {
    const aboutList = [
      { key: "%last_name%", value: "lastName" },
      { key: "%first_name%", value: "firstName" },
      { key: "%job_title%", value: "jobTitle" },
      { key: "%company%", value: "company" },
      { key: "%phone%", value: "phone" },
      { key: "%contact_image_url%", value: "contact_image_url" },
      { key: "%linkedin_url%", value: "linkedin_url" },
      { key: "%email%", value: "email" },
    ];
    let result = {};

    aboutList.forEach((item) => {
      result[item.value] =
        current?.properties?.find((x) => x.identifier_placeholder === item.key)
          ?.value || " - ";
    });

    return result;
  }, [current?.properties]);

  const handleMessageSent = () => {
    setLoading(true);
    setActiveTab("answers");
  };

  return (
    <Paper
      component={Stack}
      justify="center"
      align="center"
      className="hover-source"
      w={"100%"}
      gap={0}
      p={"sm"}
      mb={8}
      pos={"relative"}
    >
      <Text size="xs" pos={"absolute"} top={8} left={8} c={"#00000044"}>
        #{current.id}
      </Text>
      <Avatar
        color="initials"
        src={about.contact_image_url}
        imageProps={{
          referrerPolicy: "no-referrer",
        }}
        name={`${about.firstName} ${about.lastName}`}
        radius={"50%"}
        size={72}
        variant="filled"
      />

      {about.linkedin_url !== " - " && (
        <Group mt={8}>
          <ActionIcon
            component={Link}
            to={about.linkedin_url}
            target="_blank"
            variant="subtle"
          >
            <IconLinkedin size={18} />
          </ActionIcon>
        </Group>
      )}

      <PositiveChanger
        containerId={currentContainer?.id}
        is_positive={current?.is_positive}
        itemId={current?.id}
        isInDetail
      />

      <Tooltip label={`${about.firstName} ${about.lastName}`}>
        <Text
          tt="uppercase"
          fw={600}
          maw={150}
          mt={8}
          ta={"center"}
          style={{ overflowWrap: "break-word", gap: 8 }}
          display={"flex"}
        >
          {about.firstName} {about.lastName}
        </Text>
      </Tooltip>

      <Tooltip label={about.jobTitle} disabled={about.jobTitle === " - "}>
        <Text
          size="sm"
          mt={8}
          w={"100%"}
          ta={"center"}
          style={{ overflowWrap: "break-word" }}
        >
          {about.jobTitle}
        </Text>
      </Tooltip>

      <Tooltip label={about.company} disabled={about.company === " - "}>
        <Text
          size="sm"
          mt={8}
          ta={"center"}
          w={"100%"}
          style={{ overflowWrap: "break-word" }}
        >
          {about.company}
        </Text>
      </Tooltip>

      <Group w={"80%"} mt={8} pos={"relative"}>
        {tagsColumn({
          editFunction: () => updateProspect,
          wrapperProps: { py: 6, px: 8 },
          onEdited: onTagEdited,
        }).renderCell({
          row: current,
          value: current.tags.map((e) => e.name).join(", "),
        })}
      </Group>

      <Group gap={"md"} mt={16} justify="center" px={0}>
        <AddReminder inLeft />

        <QuickAddNote />

        <EmailSenderModal
          current={current}
          onSent={handleMessageSent}
          isIcon
          disabled={about.email === " - "}
        />

        {/* <LinkedinSenderModal
          current={current}
          isIcon
          onSent={handleMessageSent}
        /> */}

        <Tooltip label={lang.leads.call}>
          <ActionIcon
            variant="light"
            size={"md"}
            component={about.phone !== " - " ? "a" : null}
            href={`tel:${about.phone}`}
            disabled={about.phone === " - "}
          >
            <IconPhone size={16} />
          </ActionIcon>
        </Tooltip>

        <ConversationStart isIcon disabled={about.linkedin_url === " - "} />
      </Group>
    </Paper>
  );
};

export default MainBio;
